import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() =>
  createStyles({
    starWraper: {
      position: 'relative',
    },
    empty: {
      maskImage:
        'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjIuNDkgMiAxOS4wMiAxOC4wOSI+PHBhdGggZmlsbD0iI0Y1QTUxMiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTUuMjMzIDcuNTUgMTIgMiA4Ljc2NyA3LjU1IDIuNDg5IDguOTFsNC4yOCA0Ljc5LS42NDcgNi4zOUwxMiAxNy41bDUuODc4IDIuNTktLjY0Ny02LjM5IDQuMjgtNC43OXptMi40OTggMi41ODgtMy43ODMtLjgyTDEyIDUuOTc1IDEwLjA1MiA5LjMybC0zLjc4My44MTkgMi41NzkgMi44ODYtLjM5IDMuODUxTDEyIDE1LjMxNWwzLjU0MiAxLjU2LS4zOS0zLjg1eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)',
      display: 'block',
      backgroundColor: '#F5A512',
      verticalAlign: 'bottom',
      maskRepeat: 'no-repeat',
    },
    fullWrapper: {
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    full: {
      display: 'block',
      maskImage:
        'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjMuMzIgMi42NyAyNS4zNiAyNC4xMiI+PHBhdGggZmlsbD0iI0Y1QTUxMiIgZD0ibTE2IDIuNjY3IDQuMzEgNy40IDguMzcgMS44MTMtNS43MDYgNi4zODYuODYzIDguNTJMMTYgMjMuMzM0bC03LjgzNyAzLjQ1NC44NjMtOC41Mi01LjcwNy02LjM4NyA4LjM3LTEuODEzeiIvPjwvc3ZnPg==)',
      backgroundColor: '#F5A512',
      verticalAlign: 'bottom',
      maskRepeat: 'no-repeat',
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      gap: '1px',
    },
  }),
)

interface IProps {
  value?: number
  className?: string
  fontSize?: number
}

const StarRating: FC<IProps> = ({ value, fontSize = 23 }) => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <div className={classes.starWraper}>
        <span
          className={classes.empty}
          style={{
            height: `${fontSize}px`,
            width: `${fontSize}px`,
          }}
        />
        <div
          className={classes.fullWrapper}
          style={{
            height: `${fontSize}px`,
            width: `${Math.min(1, Math.max(value, 0)) * 100}%`,
          }}
        >
          <span
            className={classes.full}
            style={{
              height: `${fontSize}px`,
              width: `${fontSize}px`,
            }}
          />
        </div>
      </div>
      <div className={classes.starWraper}>
        <span
          className={classes.empty}
          style={{
            height: `${fontSize}px`,
            width: `${fontSize}px`,
          }}
        />
        <div
          className={classes.fullWrapper}
          style={{
            height: `${fontSize}px`,
            width: `${Math.min(1, Math.max(value - 1, 0)) * 100}%`,
          }}
        >
          <span
            className={classes.full}
            style={{
              height: `${fontSize}px`,
              width: `${fontSize}px`,
            }}
          />
        </div>
      </div>
      <div className={classes.starWraper}>
        <span
          className={classes.empty}
          style={{
            height: `${fontSize}px`,
            width: `${fontSize}px`,
          }}
        />
        <div
          className={classes.fullWrapper}
          style={{
            height: `${fontSize}px`,
            width: `${Math.min(1, Math.max(value - 2, 0)) * 100}%`,
          }}
        >
          <span
            className={classes.full}
            style={{
              height: `${fontSize}px`,
              width: `${fontSize}px`,
            }}
          />
        </div>
      </div>
      <div className={classes.starWraper}>
        <span
          className={classes.empty}
          style={{
            height: `${fontSize}px`,
            width: `${fontSize}px`,
          }}
        />
        <div
          className={classes.fullWrapper}
          style={{
            height: `${fontSize}px`,
            width: `${Math.min(1, Math.max(value - 3, 0)) * 100}%`,
          }}
        >
          <span
            className={classes.full}
            style={{
              height: `${fontSize}px`,
              width: `${fontSize}px`,
            }}
          />
        </div>
      </div>
      <div className={classes.starWraper}>
        <span
          className={classes.empty}
          style={{
            height: `${fontSize}px`,
            width: `${fontSize}px`,
          }}
        />
        <div
          className={classes.fullWrapper}
          style={{
            height: `${fontSize}px`,
            width: `${Math.min(1, Math.max(value - 4, 0)) * 100}%`,
          }}
        >
          <span
            className={classes.full}
            style={{
              height: `${fontSize}px`,
              width: `${fontSize}px`,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default StarRating
